import React from 'react';
import { formatCurrency } from '@/utils/formatters';

const STATUS_COLOR = {
  ok:      'text-success',
  warning: 'text-yellow-700',
  danger:  'text-danger',
  none:    'text-gray-500',
};

/**
 * @param {{ budget: number, spent: number, remaining: number, prevMonthTotal: number, cashback: number }}
 */
export default function KPICards({ budget = 0, spent = 0, remaining = 0, prevMonthTotal = 0, cashback = 0 }) {
  const delta = prevMonthTotal ? spent - prevMonthTotal : null;
  const pct   = prevMonthTotal ? Math.abs(Math.round((delta / prevMonthTotal) * 100)) : null;
  const upDown = delta !== null && delta < 0 ? '▼' : '▲';
  const deltaColor = delta !== null && delta < 0 ? 'text-success' : 'text-danger';

  const budgetPct = budget > 0 ? Math.round((spent / budget) * 100) : 0;
  let budgetStatus = 'ok';
  if (budgetPct >= 100) budgetStatus = 'danger';
  else if (budgetPct >= 80) budgetStatus = 'warning';

  const cards = [
    {
      label: 'Total Spent',
      value: formatCurrency(spent),
      sub:   'This month',
      color: 'border-primary',
      valColor: 'text-primary',
    },
    {
      label: 'Budget',
      value: formatCurrency(budget),
      sub:   budget
        ? (remaining >= 0
          ? `${formatCurrency(remaining)} left`
          : `${formatCurrency(Math.abs(remaining))} over`)
        : 'Not set',
      color: 'border-success',
      valColor: 'text-success',
    },
    {
      label: remaining < 0 ? 'Over Budget' : 'Remaining',
      value: remaining < 0 ? `-${formatCurrency(Math.abs(remaining))}` : formatCurrency(remaining),
      sub:   budget ? `${budgetPct}% used` : '—',
      color: remaining < 0 ? 'border-danger' : 'border-warning',
      valColor: remaining < 0 ? STATUS_COLOR.danger : STATUS_COLOR[budgetStatus],
    },
    {
      label: 'vs Last Month',
      value: pct !== null ? `${upDown} ${pct}%` : '—',
      sub:   delta !== null ? `${formatCurrency(Math.abs(delta))} ${delta < 0 ? 'less' : 'more'}` : 'No data',
      color: 'border-purple',
      valColor: delta !== null ? deltaColor : 'text-gray-500',
    },
    {
      label: 'Cashback Est.',
      value: formatCurrency(cashback),
      sub:   'Rupay + HDFC rewards',
      color: 'border-teal-500',
      valColor: cashback > 0 ? 'text-teal-600' : 'text-gray-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 p-3">
      {cards.map(({ label, value, sub, color, valColor }) => (
        <div key={label} className={`kpi-card ${color}`}>
          <span className="text-xs text-gray-500 uppercase tracking-wide font-medium leading-tight">
            {label}
          </span>
          <span className={`text-xl font-bold leading-none mt-1 ${valColor}`}>{value}</span>
          <span className="text-xs text-gray-400">{sub}</span>
        </div>
      ))}
    </div>
  );
}
